import { useState, useEffect } from "react";
import { useSnackbar } from "react-simple-snackbar";
import { format } from "date-fns";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Loader from "../components/Loader";

const PmoHome = () => {
	const [transactions, setTransactions] = useState([]);
	const [newTransaction, setNewTransaction] = useState(null);
	const [code, setCode] = useState("");
	const [transactionModal, setTransactionModal] = useState(false);
	const [loading, setLoading] = useState(false);
	const [transactionLoading, setTransactionLoading] = useState(true);

	const [dangerSnackbar] = useSnackbar({
		style: {
			zIndex: 10,
			backgroundColor: "#d81e5b",
			color: "#fff",
		},
	});

	const [successSnackbar] = useSnackbar({
		style: {
			zIndex: 10,
			backgroundColor: "#44C4A1",
			color: "#fff",
		},
	});

	const getData = async () => {
		setLoading(true);
		const requestOptions = {
			method: "GET",
		};

		const response = await fetch(
			`${process.env.REACT_APP_API_URI}/transactions/`,
			requestOptions
		);
		const data = await response.json();

		if (!response.ok) {
			dangerSnackbar("Something went wrong.");
		} else {
			setTransactions(data.transactions);
		}
		setLoading(false);
	};

	const validateQR = async (e) => {
		e.preventDefault();
		setTransactionLoading(true);
		const requestOptions = {
			method: "POST",
			body: JSON.stringify({
				code: code,
			}),
		};

		const response = await fetch(
			`${process.env.REACT_APP_API_URI}/transactions/validate`,
			requestOptions
		);
		const data = await response.json();

		if (!response.ok) {
			dangerSnackbar(data.msg);
			setNewTransaction(null);
		} else {
			setNewTransaction(data.transaction);
			successSnackbar(data.msg);
			getData();
		}
		setTransactionLoading(false);
		setCode("");
	};

	const handleTransactionClose = () => {
		setTransactionModal(false);
		setNewTransaction(null);
	};

	useEffect(() => {
		getData();
	}, []);

	return (
		<div className="content pmo-content">
			<div className="pmo-container bg-white rounded full-height">
				<Row className="pmo-header flex-row-left">
					<Col>
						<span className="pmo-brand title-md text-bold-inter">
							<span className="text-green">FAST</span>PASS
						</span>
					</Col>
					<Col className="flex-row-right">
						<Button
							className="add-transaction-btn btn-default rounded"
							onClick={() => setTransactionModal(true)}
						>
							Add
						</Button>
					</Col>
				</Row>
				<div className="pmo-body">
					<Table className="pmo-table">
						<thead>
							<tr className="text-bold-inter">
								<th className="col-2">Tower</th>
								<th className="col-2">Unit</th>
								<th className="col-2">Vehicle</th>
								<th className="col-2">Plate No</th>
								<th className="col-2">In</th>
								<th className="col-2">Out</th>
							</tr>
							<tr>
								<th className="col-2">
									<Form.Control className="rounded" />
								</th>
								<th className="col-2">
									<Form.Control className="rounded" />
								</th>
								<th className="col-2">
									<Form.Control className="rounded" />
								</th>
								<th className="col-2">
									<Form.Control className="rounded" />
								</th>
								<th className="col-2">
									<Form.Control className="rounded" />
								</th>
								<th className="col-2">
									<Form.Control className="rounded" />
								</th>
							</tr>
						</thead>
						<tbody>
							{transactions.map((transaction) => (
								<tr>
									<td className="col-2">{transaction.tower}</td>
									<td className="col-2">{transaction.unit}</td>
									<td className="col-2">{transaction.vehicle}</td>
									<td className="col-2">{transaction.plate_no}</td>
									<td className="col-2">
										{format(
											new Date(transaction.entry_datetime),
											"MMM dd, yyyy - hh:mm a"
										)}
									</td>
									<td className="col-2">
										{transaction.exit_datetime
											? format(
													new Date(transaction.exit_datetime),
													"MMM dd, yyyy - hh:mm a"
											  )
											: "--"}
									</td>
								</tr>
							))}
						</tbody>
					</Table>
				</div>
			</div>
			<Modal
				show={transactionModal}
				onHide={handleTransactionClose}
				className="scanner-modal"
				centered
			>
				<Modal.Header>
					<Modal.Title className="default-text bold-text">
						Scan QR Code
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="pt-4 pb-4">
					<Form onSubmit={validateQR} className="scanner-form">
						<Form.Control
							autoFocus
							className="rounded full"
							value={code}
							onChange={(e) => setCode(e.target.value)}
						/>
					</Form>
					<div className="transaction-modal-info border-top">
						{newTransaction && (
							<>
								<Row className="form-block">
									<Col>
										<label className="transaction-label text-green text-medium-inter block">
											Tower
										</label>
										<span className="transactin-info text-lg">
											{newTransaction.tower}
										</span>
									</Col>
									<Col>
										<label className="transaction-label text-green text-medium-inter block">
											Unit
										</label>
										<span className="transactin-info text-lg">
											{newTransaction.unit}
										</span>
									</Col>
								</Row>
								<Row className="form-block">
									<Col>
										<label className="transaction-label text-green text-medium-inter block">
											Vehicle
										</label>
										<span className="transactin-info text-lg">
											{newTransaction.vehicle}
										</span>
									</Col>
									<Col>
										<label className="transaction-label text-green text-medium-inter block">
											Plate No.
										</label>
										<span className="transactin-info text-lg">
											{newTransaction.plate_no}
										</span>
									</Col>
								</Row>
								<Row className="form-block">
									<Col>
										<label className="transaction-label text-green text-medium-inter block">
											Purpose
										</label>
										<span className="transactin-info text-lg">
											{newTransaction.purpose}
										</span>
									</Col>
									<Col>
										<label className="transaction-label text-green text-medium-inter block">
											Name
										</label>
										<span className="transactin-info text-lg">
											{newTransaction.guest.name
												? newTransaction.guest.name
												: "--"}
										</span>
									</Col>
								</Row>
								<Row className="form-block">
									<Col>
										<label className="transaction-label text-green text-medium-inter block">
											In
										</label>
										<span className="transactin-info text-lg">
											{newTransaction.entry_datetime
												? format(
														new Date(newTransaction.entry_datetime),
														"MMM dd, yyyy - hh:mm a"
												  )
												: "--"}
										</span>
									</Col>
									<Col>
										<label className="transaction-label text-green text-medium-inter block">
											Out
										</label>
										<span className="transactin-info text-lg">
											{newTransaction.exit_datetime
												? format(
														new Date(newTransaction.exit_datetime),
														"MMM dd, yyyy - hh:mm a"
												  )
												: "--"}
										</span>
									</Col>
								</Row>
							</>
						)}
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button
						type="button"
						variant="light"
						className="rounded upper text-medium-inter"
						onClick={handleTransactionClose}
					>
						Close
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	);
};

export default PmoHome;
